import { render, staticRenderFns } from "./WalletTransactionsForm.vue?vue&type=template&id=1715716a&scoped=true&"
import script from "./WalletTransactionsForm.vue?vue&type=script&lang=js&"
export * from "./WalletTransactionsForm.vue?vue&type=script&lang=js&"
import style0 from "./WalletTransactionsForm.vue?vue&type=style&index=0&id=1715716a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1715716a",
  null
  
)

export default component.exports